// src/pages/BlogDetail.tsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { db } from "../firebase/firebase";
import { doc, getDoc } from "firebase/firestore";
import { IoReturnUpBack } from "react-icons/io5";

const BlogDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState<any>(null);

  useEffect(() => {
    const fetchPost = async () => {
      if (!id) return;
      const docRef = doc(db, "blogs", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setPost(docSnap.data());
      }
    };
    fetchPost();
  }, [id]);

  if (!post) return <div className="w-full h-screen flex justify-center items-center text-4xl">Loading...</div>;

  return (
    <div className="max-w-4xl mx-auto px-4 py-8 relative">
      <button
        className="float-right bg-slate-300 opacity-50 text-blue-500 flex flex-row justify-center items-center gap-2 px-6 rounded-full underline sticky top-4 right-4 z-50"
        onClick={() => navigate(-1)}
      >
        <IoReturnUpBack className="text-5xl"/>
      
      </button>
      
      <img
        src={post.image || "/default-image.jpg"}
        alt={post.title}
        className="w-full h-auto max-w-2xl mx-auto rounded-lg mb-6"
      />
      <h1 className="text-3xl font-bold mb-4">{post.title}</h1>
      <p className="text-gray-700 text-lg whitespace-pre-line">
        {post.content}
      </p>
    </div>
  );
};

export default BlogDetail;
